import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const supplierKeys = new QueryKeyFactory('supplier')
